import React from 'react';

import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';

export interface IPolicyNote {
    agreeUrl: string,
    buttonText?: string | React.ReactNode,
    urlTextGenitive?: string,
    children?: React.ReactNode,
}

export const PolicyNote = ({
    agreeUrl,
    buttonText = 'Отправить',
    urlTextGenitive = 'Условиями обработки данных',
    children,
}: IPolicyNote): JSX.Element => {
    return (
        <Paragraph5>
            Нажимая «{buttonText}», вы соглашаетесь с&nbsp;
            <a
                href={agreeUrl}
                target='_blank'
                rel='noreferrer nofollow noopener'
                data-test={'linkAgree'}
            >
                <b>{urlTextGenitive}</b>
            </a>
            {children}
        </Paragraph5>
    );
};
